export default "__VITE_ASSET__db5527ca__"